export default {
  configPage: {
    notFound: 'ID do workspace não encontrado',
    title: 'Configurações do Workspace',
    dialogDescription: 'Gerencie a visão geral e os tokens de API do workspace',
    tabs: {
      overview: 'Geral',
      users: 'Usuários',
      apiTokens: 'Tokens',
      authorizedApps: 'Apps',
      security: 'Segurança'
    },
    dangerZone: {
      title: 'Zona de Perigo',
      description: 'Ações irreversíveis para este workspace.',
      deleteTitle: 'Excluir workspace',
      deleteDescription: 'Esta ação é permanente e não pode ser desfeita. Todos os dados do workspace serão removidos.',
      deleteButton: 'Excluir',
      confirmTitle: 'Confirmar exclusão do workspace',
      confirmDescription: 'Esta ação é irreversível. Digite o nome do workspace para confirmar.',
      confirmLabel: 'Digite o nome do workspace para confirmar:',
      confirmHint: 'Digite "{{name}}" para confirmar'
    }
  },
  overview: {
    title: 'Geral',
    description: 'Gerencie as informações e configurações do seu workspace',
    saving: 'Salvando...',
    save: 'Salvar'
  },
  users: {
    title: 'Usuários do Workspace',
    description: 'Gerencie quais usuários têm acesso a este workspace',
    pendingInvites: 'Convites Pendentes',
    activeUsers: 'Usuários Ativos'
  },
  apiTokens: {
    title: 'Tokens de API',
    description: 'Gerencie tokens de API para acesso de terceiros',
    create: 'Criar',
    createTitle: 'Criar Token de API',
    createDesc: 'Crie um novo token vinculado a este workspace.',
    createSuccessDesc: 'Seu token de API foi criado com sucesso. Você pode copiá-lo agora ou acessá-lo mais tarde na lista de tokens.',
    tokenName: 'Nome do token',
    tokenNamePlaceholder: 'ex: Integração de Produção',
    setExpiration: 'Definir expiração',
    expiresAt: 'Expira em',
    yourToken: 'Seu Token de API',
    copyToken: 'Copiar token',
    copyWarning: '⚠️ Importante: Copie este token agora! Após fechar este diálogo, apenas o prefixo do token será mostrado por segurança. O token completo não pode ser recuperado depois.',
    noTokens: 'Nenhum token de API',
    noTokensDesc: 'Crie um token de API para permitir que integrações de terceiros acessem endpoints específicos.',
    createFirst: 'Criar seu primeiro token',
    availableApis: 'APIs Disponíveis',
    apisDescription: 'Endpoints acessíveis com tokens de API deste workspace',
    swaggerLink: 'Para detalhes completos dos endpoints, consulte a documentação Swagger',
    copy: 'Copiar',
    copyPrefixBtn: 'Copiar Prefixo',
    copyFullToken: 'Copiar token completo',
    copyPrefix: 'Copiar prefixo do token (regenere para obter o token completo)',
    regenerate: 'Regenerar',
    regenerateTitle: 'Regenerar token - cria um novo token e mostra para você',
    active: 'Ativo',
    inactive: 'Inativo',
    created: 'Criado',
    expires: 'Expira',
    usageCount: 'Contagem de uso',
    tokenCopied: 'Token copiado para a área de transferência',
    prefixCopied: 'Prefixo do token copiado para a área de transferência',
    copyFailed: 'Falha ao copiar o token',
    copyPrefixFailed: 'Falha ao copiar o prefixo do token',
    revoked: 'Token revogado',
    renewed: 'Token renovado com sucesso',
    regenerated: 'Token regenerado com sucesso'
  },
  authorizedApps: {
    title: 'Apps Conectados',
    description: 'Aplicações que receberam acesso a este workspace via OAuth.',
    empty: 'Nenhum app conectado',
    emptyDesc: 'Quando aplicações se conectarem a este workspace via OAuth, elas aparecerão aqui.',
    columns: {
      app: 'Aplicação',
      scopes: 'Permissões',
      lastUsed: 'Último uso',
      authorizedAt: 'Autorizado em',
      authorizedBy: 'Autorizado por',
      status: 'Status'
    },
    status: {
      on: 'Ligado',
      off: 'Desligado',
      onTooltip: 'Sessão ativa — o app tem um access token válido e está pronto para uso.',
      offTooltip: 'Ocioso — a autorização continua válida, mas o access token expirou. O app vai reconectar automaticamente no próximo uso.'
    },
    scopeLabels: {
      'mcp_read': 'MCP Leitura',
      'mcp_write': 'MCP Escrita',
      'mcp_execute': 'MCP Execução',
      'mcp_admin': 'MCP Admin',
      'api_read': 'API Leitura',
      'api_write': 'API Escrita',
      'api_execute': 'API Execução',
      'api_admin': 'API Admin'
    },
    neverUsed: 'Nunca',
    revoke: 'Revogar',
    revoked: 'Acesso revogado com sucesso',
    revokeError: 'Falha ao revogar acesso',
    revokeDialog: {
      title: 'Revogar acesso',
      description: 'Tem certeza que deseja revogar o acesso de "{{appName}}"? A aplicação perderá acesso imediatamente a este workspace e precisará ser re-autorizada.'
    },
    share: {
      button: 'Compartilhar detalhes de conexão',
      title: 'Detalhes de conexão',
      description: 'Use estas URLs e escopos para conectar aplicações externas a este workspace via OAuth.',
      mcpTitle: 'Servidor MCP',
      mcpDescription: 'Para uso com clientes compatíveis com MCP (Claude, Cursor, Windsurf, etc.).',
      apiTitle: 'REST API',
      apiDescription: 'Para aplicações que chamam os endpoints REST do Prodgy diretamente via tokens OAuth.',
      urlLabel: 'URL',
      scopesLabel: 'Escopos disponíveis',
      copyUrl: 'Copiar URL',
      urlCopied: 'URL copiada para a área de transferência',
      copyFailed: 'Falha ao copiar para a área de transferência'
    }
  }
};
